import type { AxiosResponse } from 'axios'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { IResponseApi } from '@/modules/Core/interfaces'
import type { ICatalogosHojaVida, IHojaVidaResponse, IRegistroHojaVida, ModoHojaVida, RecursoHojaVida } from '@/modules/Administracion/interfaces'

interface ISoporteHojaVida {
  archivo: string
  nombre: string
  mimeType: string
}

export class HojaVidaService extends BaseService<IRegistroHojaVida> {
  constructor () {
    super({ baseUrl: 'curriculum/' })
  }

  private target (modo: ModoHojaVida, empleadoId: number) {
    return modo === 'personal' ? 'mine' : `employee/${empleadoId}`
  }

  async general (): Promise<AxiosResponse<IResponseApi<ICatalogosHojaVida>>> {
    return this.http.get<IResponseApi<ICatalogosHojaVida>>('/general').catch(this.errorHandle)
  }

  async hojaVida (modo: ModoHojaVida, empleadoId: number): Promise<AxiosResponse<IResponseApi<IHojaVidaResponse>>> {
    return this.http.get<IResponseApi<IHojaVidaResponse>>(`/${this.target(modo, empleadoId)}`).catch(this.errorHandle)
  }

  async guardar (modo: ModoHojaVida, empleadoId: number, recurso: RecursoHojaVida, form: FormData, id?: number): Promise<AxiosResponse<IResponseApi<IRegistroHojaVida>>> {
    const url = `/${this.target(modo, empleadoId)}/${recurso}${id ? `/${id}` : ''}`
    return id ? this.putFile(url, form) : this.postFile(url, form)
  }

  async eliminar (modo: ModoHojaVida, empleadoId: number, recurso: RecursoHojaVida, id: number): Promise<AxiosResponse<IResponseApi<boolean>>> {
    return this.http.delete<IResponseApi<boolean>>(`/${this.target(modo, empleadoId)}/${recurso}/${id}`).catch(this.errorHandle)
  }

  async soporte (modo: ModoHojaVida, empleadoId: number, recurso: RecursoHojaVida, id: number): Promise<AxiosResponse<IResponseApi<ISoporteHojaVida>>> {
    return this.http.get<IResponseApi<ISoporteHojaVida>>(`/${this.target(modo, empleadoId)}/${recurso}/${id}/support`).catch(this.errorHandle)
  }

  async validarSoporte (empleadoId: number, recurso: RecursoHojaVida, id: number, validar: boolean): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http.put<IResponseApi<unknown>>(`/employee/${empleadoId}/${recurso}/${id}/validate-support`, { validar }).catch(this.errorHandle)
  }
}
